import React from 'react'
import { TextInput } from '../../components/form/Input';
import Alert, { AlertPropsType } from '../../components/ui/alert';
import { SearchDeliveryReportErrors } from './ShippingServices';
import { Button } from '../../components/ui/button';
import { IoSearch } from 'react-icons/io5';

const DailyDeliverySearchData = () => {

  const [deliveryNumber, setDeliveryNumber] = React.useState<string>("");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [alert, setAlert] = React.useState<AlertPropsType | null>();
  const [errors, setErrors] = React.useState<SearchDeliveryReportErrors | null>(null);

  const deleteErrorHandler = (event: React.ChangeEvent<HTMLInputElement> | string) => {
    if (errors) {
      const newErrors = errors;
      const removedProperty = typeof event === "string" ? event : event.target.name;
      delete newErrors[removedProperty];
      setErrors(newErrors);
    };
  };

  const submitHandler = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsLoading(true);
    setAlert(null);
    setErrors(null);

    // Simulate form submission
    setTimeout(() => {
      setIsLoading(false);
      // Simulate success or error response
      const isSuccess = Math.random() > 0.5; // Randomly decide success or failure
      if (isSuccess) {
        console.log("data success")
      } else {
        setErrors({ deliveryNumber: 'No. Pengiriman tidak valid.' });
        setAlert({ variant: 'error', message: 'Terjadi kesalahan saat pencarian data.' });
      }
    }, 2000);
  };

  return (
    <>
      <form onSubmit={submitHandler} className='p-4'>
        <div className='grid lg:grid-cols-2 gap-8'>
          <div className='flex flex-col gap-1.5'>
            <label className='font-semibold'>No. Pengiriman</label>
            <TextInput
              required
              name="deliveryNumber"
              value={deliveryNumber}
              placeholder="No. Pengiriman"
              disabled={isLoading}
              error={errors?.deliveryNumber}
              onChange={(e: any) => {
                deleteErrorHandler(e.target.name);
                setDeliveryNumber(e.target.value)
              }}
            />
          </div>
          <div className='flex items-end justify-start'>
            <Button
              disabled={isLoading}
              type='submit'
              className="bg-secondary-blue hover:!bg-sky-400 transition-all ease-in-out duration-300 text-white py-[10px] w-36 rounded-xl font-bold flex items-center gap-1.5 text-sm uppercase"
            >
              <>
                <IoSearch size={10} />
                Cari
              </>
            </Button>
          </div>
        </div>
      </form>
      {alert && <Alert options={alert} />}
    </>
  )
}

export default DailyDeliverySearchData